import React from "react";
import { Tab } from "@mui/material";
import ProductImage from "../../../../../pages/shared/components/product-image";
import { ProductTabProps } from "./types";

import "./styles.scss";

const classNameBase = "scd-product-selection-tab";
export default function ProductTab({
  title,
  value,
  selectedProduct,
  ...other
}: ProductTabProps): React.JSX.Element {
  const selected = selectedProduct === value.productRef;
  return (
    <Tab
      title={title}
      icon={<ProductImage product={value.productRef} />}
      disableRipple={true}
      value={value}
      wrapped
      classes={{
        root: `${classNameBase}-root`,
        labelIcon: `${classNameBase}-labelIcon`,
        textColorInherit: `${classNameBase}-textColorInherit`,
        textColorPrimary: `${classNameBase}-textColorPrimary`,
        textColorSecondary: `${classNameBase}-textColorSecondary`,
        selected: `${classNameBase}-selected`,
        disabled: `${classNameBase}-disabled`,
        fullWidth: `${classNameBase}-fullWidth`,
        wrapped: `${classNameBase}-wrapped`,
        iconWrapper: selected
          ? `${classNameBase}-wrapper-selected`
          : `${classNameBase}-wrapper`,
      }}
      {...other}
    />
  );
}
